import { Component } from '@angular/core';
import { TitleService } from '@memberjunction/ng-shared';

@Component({
  standalone: false,
  selector: 'app-root',
  template: '<mj-explorer-app />'
})
export class AppComponent {
  constructor(titleService: TitleService) {
    titleService.setBaseTitle('SoundPost Bridge');
  }
}